import Vue from "vue";
import Router from "vue-router";
import init_menu from "../views/init_menu.vue";
import dashboard from "../views/dashboard.vue";
import listSocios from "../views/listSocios.vue";
import createSocio from "../views/createSocio.vue";
import createSocio2 from "../views/createSocio2.vue";
import createSocio3 from "../views/createSocio3.vue";
import listPayments from "../views/listPayments.vue";
import login from "../views/login.vue";
import resetPassword from "../views/resetPassword.vue";
import profile from "../views/profile.vue";
import csv from "../views/csv.vue";
import payment from "../views/payment.vue";
import edit from "../views/edit.vue";
import suporte from "../views/suporte.vue";
import {verifyToken} from "../api/Auth/apiAuth.js";
import {mutations} from "../store/modules/createSocio";

Vue.use(Router);

export default new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "login",
      component: login,
      beforeEnter: (to, from, next) => {
        if(localStorage.getItem("email")&&localStorage.getItem("token")) {
          verifyToken({email: localStorage.getItem("email"), token: localStorage.getItem("token")}).then(response => {
            cleanCreateMutations();
            if(response.data.code == "TokenVerified") next('/dashboard');
            else next();
          }).catch((error) => {if(error) next()});
        } else next();    
      }
    },
    {
      path: "/init_menu",
      name: "Menu",
      component: init_menu,
      beforeEnter: (to, from, next) => {
        cleanCreateMutations();
        next();
      }
    },
    {
      path: "/reset_password",
      name: "Reset Password",
      component: resetPassword,
      beforeEnter: (to, from, next) => {
        cleanCreateMutations();
        next();
      }
    },
    {
      path: "/dashboard",
      name: "Dashboard",
      component: dashboard,
      beforeEnter: (to, from, next) => {
        cleanCreateMutations();
        if(from.path=="/init_menu") next();
        else{
          verifyToken({email: localStorage.getItem("email")}).then(response => {
            if(response.data.code == "TokenVerified") next()
            else next('/');
          }).catch((error) => {if(error) next('/')});
        }
      }
    },
    {
      path: "/listSocios",
      name: "Listar",
      component: listSocios,
      beforeEnter: (to, from, next) => {
        cleanCreateMutations();
        verifyToken({email: localStorage.getItem("email")}).then(response => {
          if(response.data.code == "TokenVerified") next();
          else next('/');
        }).catch((error) => {if(error) next('/')});
      }
    },
    {
      path: "/createSocio",
      name: "Registar",
      component: createSocio,
      beforeEnter: (to, from, next) => {
        verifyToken({email: localStorage.getItem("email")}).then(response => {
          if(response.data.code == "TokenVerified") next();
          else next('/');
        }).catch((error) => {if(error) next('/')});
      }
    },
    {
      path: "/createSocio2",
      name: "Registar",
      component: createSocio2
    },
    {
      path: "/createSocio3",
      name: "Registar",
      component: createSocio3
    },
    {
      path: "/listPayments",
      name: "Pagamentos",
      component: listPayments,
      beforeEnter: (to, from, next) => {
        cleanCreateMutations();
        verifyToken({email: localStorage.getItem("email")}).then(response => {
          if(response.data.code == "TokenVerified") next();
          else next('/');
        }).catch((error) => {if(error) next('/')});
      }
    },
    {
      path: "/profile",
      name: "Profile",
      component: profile,
      beforeEnter: (to, from, next) => {
        cleanCreateMutations();
        next();
      }
    },
    {
      path: "/csv",
      name: "Download",
      component: csv,
      beforeEnter: (to, from, next) => {
        cleanCreateMutations();
        verifyToken({email: localStorage.getItem("email")}).then(response => {
          if(response.data.code == "TokenVerified") next()
          else next('/');
        }).catch((error) => {if(error) next('/')});
      }
    },
    {
      path: "/payment",
      name: "Pagamento",
      component: payment,
      props: true,
      beforeEnter: (to, from, next) => {
          cleanCreateMutations();
          verifyToken({email: localStorage.getItem("email")}).then(response => {
              if(response.data.code == "TokenVerified") next()
              else next('/');
          }).catch((error) => {if(error) next('/')});
      }
    },
    {
      path: "/edit",
      name: "Edit",
      component: edit,
      props: true,
      beforeEnter: (to, from, next) => {
        cleanCreateMutations();
        verifyToken({email: localStorage.getItem("email")}).then(response => {
          if(response.data.code == "TokenVerified") next()
          else next('/');
        }).catch((error) => {if(error) next('/')});
      }
    },
    {
      path: "/suporte",
      name: "Suporte",
      component: suporte,
      props: true,
      beforeEnter: (to, from, next) => {
        cleanCreateMutations();
        verifyToken({email: localStorage.getItem("email")}).then(response => {
          if(response.data.code == "TokenVerified") next()
          else next('/');
        }).catch((error) => {if(error) next('/')});
      }
    },
    { 
      path: '*', 
      redirect: '/' 
    }
  ]
});

function cleanCreateMutations() {
  mutations.changeName('');
  mutations.changeEmail('');
  mutations.changeBirthdayDate(null);
  mutations.changePhoneNumber('');
  mutations.changeAddress('');
  mutations.changeNumberOfPayments(0);
  mutations.changeType(1);
}
